export function useVersionedAsset() {
    function cdn() {
        return process.env.MIX_CDN_URL ? process.env.MIX_CDN_URL : ''
    }

    function mix(path, mixManifest) {
        return cdn() + (mixManifest.hasOwnProperty(path) ? mixManifest[path] : path)
    }

    return {
        mix,
    }
}